import React, { useState } from 'react';
import { UserPlus } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';

/* Alta del acceso al portal, justo después de cerrar un trabajo */
export default function ModalAccesoPortal({ cliente_id, clienteNombre, onClose }) {
  const [f, setF] = useState({ nombre: '', email: '', ve_importes: true, invitar: true });
  const [guardando, setGuardando] = useState(false);

  const crear = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await api.post(`/agency/clientes/${cliente_id}/contactos`, f);
      toast.success(f.invitar ? `Listo, le mandamos los datos de acceso a ${f.email}` : 'Usuario creado', { duration: 6000 });
      onClose();
    } catch (err) { toast.error(err.response?.data?.error || 'No se pudo crear'); }
    finally { setGuardando(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 440 }}>
        <h2>¿Le damos acceso al portal?</h2>
        <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
          {clienteNombre} ya es cliente. Desde el portal va a poder ver el avance del trabajo, sus pagos y las novedades.
          Si preferís hacerlo más adelante, cerrá esta ventana: lo tenés en su ficha cuando quieras.
        </p>
        <form onSubmit={crear}>
          <div className="form-group"><label>Nombre de la persona</label>
            <input value={f.nombre} onChange={e => setF({ ...f, nombre: e.target.value })} placeholder="Quién va a entrar" autoFocus /></div>
          <div className="form-group"><label>Email</label>
            <input type="email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} required placeholder="nombre@empresa.com" /></div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 8, cursor: 'pointer' }}>
            <input type="checkbox" checked={f.ve_importes} onChange={e => setF({ ...f, ve_importes: e.target.checked })} style={{ width: 16, height: 16 }} />
            Puede ver importes y facturas
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 18, cursor: 'pointer' }}>
            <input type="checkbox" checked={f.invitar} onChange={e => setF({ ...f, invitar: e.target.checked })} style={{ width: 16, height: 16 }} />
            Enviarle ahora los datos de acceso por mail
          </label>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Ahora no</button>
            <button type="submit" className="btn btn-primary" disabled={guardando}><UserPlus size={15} /> {guardando ? 'Creando...' : 'Crear acceso'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
